module.exports = __webpack_public_path__ + "static/img/gzh_xy.51d1d30d.jpeg";